// Components
import Modal from "components/organism/modal-v2";
import Button from "components/v1/Button";

// Assets
import IInfoRounded from "assets/i-info-rounded";

const ModalResultTopUp = ({
  onClose,
  isOpen,
  description,
  ...props
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} {...props}>
      <div
        className="w-[400px] z-[42] bg-white rounded-md border-[0.5px] border-solid border-[#ECECEC] 
        shadow-[0px_1px_3px_0px_rgba(16,16,16,0.10),_0px_1px_2px_0px_rgba(16,16,16,0.06)]"
      >
        <div className="flex items-center gap-2 px-4 py-2 border-b border-solid border-[#D8D8D9]">
          <IInfoRounded width="24" height="24" />
          <p className="text-[17px] font-inter-semibold leading-[28px]">Refresh halaman</p>
        </div>

        <div className="px-4 py-2">
          <p className="text-[13px] font-inter text-[#808285]">Silakan lakukan pembayaran dan refresh halaman untuk melihat pembaruan kredit terbaru.</p>
        </div>

        <div
          className={
            "flex items-center justify-end gap-4 px-4 py-2 border-t border-solid border-[#D8D8D9]"
          }
        >
          <Button onClick={onClose} text="Tutup" />
        </div>
      </div>
    </Modal>
  );
};

const Wrapper = ({ isOpen, ...props }) => {
  if (!isOpen) return null;
  return <ModalResultTopUp isOpen={isOpen} {...props} />;
};

export default Wrapper;
